import JSZip from "jszip";


export interface IZipBuilder {
   // addFile(fileName: string, blob: Blob);
    addCanvasFileAsync(filePath: string[], fileExtension: string, canvas: HTMLCanvasElement): Promise<any>;
    getFileCount(): number;
}

export class ZipBuilder implements IZipBuilder {

    private zip: JSZip;
    private fileCount: number = 0;

    constructor() {
        this.zip = new JSZip();

    }

    getFileCount(): number {
        return this.fileCount;
    }

//    addFile(folder: string;  fileName: string, blob: Blob) {
 //       this.zip.file(fileName, blob, { base64: true });
//
 //   }

    downloadAsync(zipFileName: string): Promise<any> {

        return this.zip.generateAsync({ type: "blob" })
            .then(content => {
                // see FileSaver.js
                //    saveAs(content, "example.zip");


                // make and click a temporary link to download the Blob
                const link = document.createElement("a")
                link.href = URL.createObjectURL(content);
                link.download = zipFileName;
                link.click()
                link.remove()

            });

    }

    addCanvasFileAsync(fileAndPath: string[], fileExtension: string, canvas: HTMLCanvasElement): Promise<any> {

        // Hackery
        var promiseResolve;
        var promise = new Promise<any>(resolve => {
            promiseResolve = resolve;
        });

        canvas.toBlob(canvasBlob =>
        //{ base64: true });
        {

            var targetFolder = this.zip;
            for (var i = 0; i < fileAndPath.length -1; i++)
                if (fileAndPath.length > 1) {
                    targetFolder = targetFolder.folder(fileAndPath[i]);

                }
            targetFolder.file(`${fileAndPath[fileAndPath.length - 1]}.${fileExtension}`, canvasBlob, { base64: true });
            this.fileCount++;
            promiseResolve(canvas);

        });
        return promise;


        //this.zip.file("smile.png", canvasBlob, { base64: true });

        //zip.generateAsync({ type: "blob" }).then(content => {
        //    // see FileSaver.js
        //    //    saveAs(content, "example.zip");


        //    // make and click a temporary link to download the Blob
        //    const link = document.createElement("a")
        //    link.href = URL.createObjectURL(content);
        //    link.download = "test.zip"
        //    link.click()
        //    link.remove()

        //});



    }
}



// WEBPACK FOOTER //
// ./ClientApp/scripts/IZipBuilder.ts